"use client";

import { PreviewAdapter, useEditorPreviewRenderArgs } from "@/features/previews";

import { QRPreviewProps } from "./types";

import "./styles.scss";

export const QRPreviewData = ({
  data,
  previewTranslations,
  isQRInit,
  defaultPreviewTitle,
}: QRPreviewProps) => {
  const previewAdapterProps = useEditorPreviewRenderArgs({
    data: data?.type ? data : { ...data, type: "empty", defaultPreviewTitle },
    previewTranslations,
    isQRInit,
  });

  if (!previewAdapterProps) {
    return <div className="qr-preview__layout__image" />;
  }

  return (
    <div className="qr-preview__layout__image">
      <PreviewAdapter {...previewAdapterProps} />
    </div>
  );
};
